import { FEATURE_FLAGS_RECEIVED } from '../constants/actionTypes.js'

const initialState = {}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FEATURE_FLAGS_RECEIVED:
      return Object.assign({}, state, action.value)
    default:
      return state
  }
}

export default reducer
export { initialState }
